<template>
    <div class="user-edit-form-container">
        <Message :message="error.msg" type="error" v-for="error in errors.items"></Message>
        <h2 class="title">{{title}}</h2>
        <form id="user-edit">
            <div class="personal-data">
                <div class="input" v-if="formMode === 'register'">
                    <span :class="{required: register}" class="label">{{$t('account.login')}}</span>
                    <input :placeholder="$t('account.login')" name="login" type="text" v-model="username"
                           v-validate="'required|email'">
                </div>
                <div class="input" v-if="formMode !== 'register'">
                    <span :class="{required: register}" class="label">{{$t('account.login')}}</span>
                    <input :placeholder="$t('account.login')" disabled name="login" type="text"
                           v-model="username">
                </div>
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.lastName')}}</span>
                    <input :placeholder="$t('account.lastName')" type="text" v-model="secondName">
                </div>
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.firstName')}}</span>
                    <input :placeholder="$t('account.firstName')" type="text" v-model="firstName">
                </div>
            </div>
            <div class="password-data">
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.password')}}</span>
                    <input :placeholder="$t('account.password')" autocomplete="new-password" name="password"
                           v-if="formMode === 'register'"
                           ref="password"
                           type="password" v-model="password" v-validate="'required|min:8'">
                    <input :placeholder="$t('account.password')" autocomplete="new-password" name="password"
                           ref="password"
                           type="password"
                           v-else v-model="password" v-validate="'min:8'">
                </div>
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.repeatPassword')}}</span>
                    <input data-vv-as="password" data-vv-rules="confirmed:password"
                           v-if="formMode === 'register' || password.length > 0"
                           :placeholder="$t('account.repeatPassword')" name="password_confirmation" type="password"
                           v-model="password2"
                           v-validate="'required|confirmed:password'">
                    <input :placeholder="$t('account.repeatPassword')" data-vv-as="password"
                           data-vv-rules="confirmed:password"
                           name="password_confirmation" type="password" v-else
                           v-model="password2"
                           v-validate="'confirmed:password'">
                </div>
            </div>
            <div class="isactive" v-if="isAdmin && formMode !=='myAccount'">
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.status')}}</span>
                    <Multiselect :allow-empty="false" :close-on-select="true"
                                 :deselectLabel="$t('multiselect.deselectLabel')"
                                 :options="statuses"
                                 :placeholder="$t('multiselect.placeholder')"
                                 :searchable="false"
                                 :selectLabel="$t('multiselect.selectLabel')"
                                 :selectedLabel="$t('multiselect.selectedLabel')"
                                 :show-labels="false"
                                 class="role-select"
                                 label="label"
                                 track-by="id"
                                 v-model="status"
                    ></Multiselect>
                </div>
            </div>
            <div class="role" v-if="isAdmin && formMode !=='myAccount'">

                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.role')}}</span>
                    <Multiselect class="role-select" v-model="selectedRole" :options="roles"
                                 :searchable="false"
                                 :close-on-select="true"
                                 :show-labels="false"
                                 :allow-empty="false"
                                 :deselectLabel="$t('multiselect.deselectLabel')"
                                 :placeholder="$t('multiselect.placeholder')"
                                 :selectLabel="$t('multiselect.selectLabel')"
                                 :selectedLabel="$t('multiselect.selectedLabel')"
                                 label="label"
                                 track-by="id"


                    ></Multiselect>
                </div>
            </div>
            <div class="role-label" v-if="formMode === 'myAccount'">
                <div class="input">
                    <span :class="{required: register}" class="label">{{$t('account.role')}}</span>
                    <input disabled name="role"" type="text"
                    :placeholder="$t(`roles.${this.$store.getters.role}`)">
                </div>
            </div>
            <div class="groups"
                 v-if="isAdmin && formMode !=='myAccount' && (selectedRole.id==='EMPLOYEE' || selectedRole.id==='SUPERVISOR')">
                <div class="input">
                    <span class="label">{{$t('account.groups')}}</span>
                    <Multiselect :options="groups"
                                 :searchable="true"
                                 class="group-select"
                                 :multiple="true"
                                 track-by="id"
                                 label="name"
                                 :value="userGroups"
                                 v-model="selectedGroups"
                                 :deselectLabel="$t('multiselect.deselectLabel')"
                                 :placeholder="$t('multiselect.placeholder')"
                                 :selectLabel="$t('multiselect.selectLabel')"
                                 :selectedLabel="$t('multiselect.selectedLabel')"
                    ></Multiselect>
                </div>
            </div>
        </form>
        <div class="controls">
            <SubmitButton :button-text="$t('buttons.submit')" @save="save"></SubmitButton>
            <CancelButton :button-text="$t('buttons.cancel')" @cancel="cancel"></CancelButton>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message';
import SubmitButton from "@/components/helpers/SubmitButton";
import CancelButton from "@/components/helpers/CancelButton";

const GroupsRepostiory = RepositoryFactory.get('groups');
export default {
  name: 'UserAccount',
  components: {
    SubmitButton,
    Message,
    Multiselect,
    CancelButton,
  },
  data() {
    return {
      selectedRole: {},
      selectedGroups: [],
      userGroups: [],
      roles: [
        {id: 'EMPLOYEE', label: this.$t('roles.EMPLOYEE')},
        {id: 'SUPERVISOR', label: this.$t('roles.SUPERVISOR')},
        {id: 'ADMINISTRATOR', label: this.$t('roles.ADMINISTRATOR')}],
      username: this.user.username,
      firstName: this.user.firstName,
      secondName: this.user.secondName,
      groups: [],
      // errors: [],
      password: '',
      password2: '',
      status: '',
      statuses: [
        {id: false, label: this.$t('account.inactive')},
        {id: true, label: this.$t('account.active')},
      ],
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    formMode: {
      type: String,
      required: true,
    },
  },
  methods: {
    validate() {
      if (this.formMode === 'register') {
        if (this.firstName && this.username && this.secondName && this.selectedRole && this.password) {
          return true;
        }
      } else if (this.formMode === 'editUser') {
        if (this.firstName && this.username && this.secondName && this.selectedRole) {
          return true;
        }
      } else if (this.formMode === 'myAccount') {
        return true;
      }
      return false;
    },
    async save() {
      /*      if (this.password !== '' && this.password2 !== this.password) {
              this.password2 = ' ';
            } */
      try {
        await this.$validator.validateAll();
        if (this.validate() && this.errors.items.length <= 0) {
          const val = {
            username: this.username,
            firstName: this.firstName,
            secondName: this.secondName,
            password: this.password,
            status: this.status.id,
          };
          if (this.user.id) {
            val.id = this.user.id;
          }
          if (this.formMode !== 'myAccount') {
            val.role = this.selectedRole.id;
          }
          const groups = [];
          this.selectedGroups.forEach((v) => {
            groups.push(v.id);
          });
          val.groups = groups;
          this.$emit('save', val);
        } else {
          this.$emit('setMessage', {message: this.$t('general.requiredFields'), type: 'error'});
        }
      } catch (e) {
        this.password2 = '';
      }
    },
    cancel() {
      this.username = this.user.username;
      this.firstName = this.user.firstName;
      this.secondName = this.user.secondName;
      this.$emit('cancel');
    },
  },
  async mounted() {
    this.$validator.localize(this.$i18n.locale, {
      messages: {
        required: field => this.$t('validation.requiredFields'),
        confirmed: field => this.$t('validation.passwordMatch'),
        min: field => this.$t('validation.passwordLength'),
        email: field => this.$t('validation.login'),
      },
    });
    if (this.isAdmin) {
      const {token} = this.$store.getters;
      this.groups = await GroupsRepostiory.getAllGroupsIndexes(token);
      if (this.formMode === 'myAccount') {
        this.selectedGroups = this.$store.getters.groups;
        this.userGroups = this.$store.getters.groups;
      } else if (!(Object.entries(this.user).length === 0 && this.user.constructor === Object)) {
        const usergroups = Object.keys(this.user.groups)
          .map(key => ({
            id: Number(key),
            name: this.user.groups[key],
          }));
        this.userGroups = usergroups;
        this.selectedGroups = usergroups;
        this.status = this.statuses.find(x => x.id === this.user.status);
      }
      if (this.user.id) {
        this.selectedRole = this.roles.find(role => role.id === this.user.role);
      }
      if ((Object.entries(this.user).length === 0 && this.user.constructor === Object)) {
        this.selectedRole = this.roles.find(role => role.id === 'EMPLOYEE');
      }
    }
  },
  computed: {
    two() {
      return this.formMode === 'myAccount';
    },
    register() {
      return this.formMode === 'register';
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>

<style lang="scss" scoped>
    * {

    }

    .user-edit-form-container {
        //width: 100%;
        margin: 50px 36px;
        margin-bottom: 80px;
    }

    .personal-data, .password-data, .role, .groups, .isactive, .role-label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include media('<480px') {
            flex-direction: column;
        }

        .input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 32%;
            // color: $baseTextColor;
            @include media('<480px') {
                width: 100%;
            }

            &.two {
                width: 49%;
            }

            .label {
                font-size: rem(15px);
                font-weight: 900;
                line-height: 40px;

                &.required {
                    &:before {
                        content: '* ';
                        color: $red;
                    }
                }
            }

            input {
                //margin: 20px 0;
                border: 1px solid $border-gray;
                border-radius: 5px;
                box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16);
                font-size: rem(14px);
                padding: 14px 0 14px 30px;
                width: 100%;
                box-sizing: border-box;

            }
        }
    }

    .password-data {
        .input {
            width: 49%;
            @include media('<480px') {
                width: 100%;
            }
        }

    }

    .cancel {
        background-color: $marine-blue;
        margin-left: 20px;
        border: 1px solid $marine-blue;
        cursor: pointer;
        transition: 300ms all ease-in;

        &:hover {
            background-color: white;
            color: $marine-blue;
        }
    }

    .controls {
        display: flex;
        justify-content: space-between;
        margin-top: 70px;
        width: 350px;
        @include media('<480px') {
            flex-direction: column;
            margin-top: 20px;
        }

        button {
            @include media('<480px') {
                width: 100%;
                margin: 10px 0;
            }
        }
    }

    .role, .groups, .isactive {
        .input {
            width: 100%;

            .role-select {
                box-shadow: 0 1px 8px 0 $baseShadow;
            }
        }
    }

    .role-label {
        margin-top: rem(50px);
    }
</style>
